<template>
  <div>
    <searchMatch />
    <postReview />
<!--    <update-review></update-review>-->
  </div>
</template>

<script>
import searchMatch from "@/components/Modals/reviewSystems/searchMatch";
import postReview from "@/components/Modals/reviewSystems/PostReview";
// import updateReview from "./updateReview";

export default {
  data() {
    return {
    };
  },
  components: {
    // updateReview,
    searchMatch,
    postReview,
  },
  async mounted() {
    // set match id if emited id. this is coming from post photos button
    // window.eventBus.$on("matchID", val => {
    //   console.log('from reviewbox',val);
    //   this.matchId = val;
    // })

  }
}
</script>

<style>

</style>
